import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { AlertDialogService } from 'src/app/Services/Alert/alert.service';
import { CommonService } from 'src/app/Services/Common/common.service';
import { CommonGridService } from 'src/app/Services/Common/grid.service';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
declare var $: any;

@Component({
  selector: 'app-add-employee',
  templateUrl: './add-employee.component.html',
  styleUrls: ['./add-employee.component.css']
})
export class AddEmployeeComponent implements OnInit {
  @ViewChild('invoiceGrid', { static: false }) invoiceGrid: jqxGridComponent;
  WebAPImasteruri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  EmployeeForm: FormGroup;
  DepartmentList: any;
  PaymentModeList: any;
  BranchList: any;
  GridColumns: any;
  Gridsource: any;
  GridToolBar: any;
  GridAdapter: any;
  FileList: any;
  StoredFileName: string = "";
  today = new Date();
  constructor(
    private formBuilder: FormBuilder,
    private property: PropertiesService,
    public commonService: CommonService,
    private http: HttpClient,
    private gridService: CommonGridService,
    private datePipe: DatePipe,
    private httpRequestService: HttpRequestService,
    private alert: AlertDialogService,
    private route: ActivatedRoute
  ) { this.createForm(); }

  createForm() {
    this.EmployeeForm = this.formBuilder.group({
      EmployeeID: [],
      EmpCode: [],
      FullName: [],
      Email: [],
      Mobile: [],
      Gender: [],
      AadhaarNo: [],
      DoB: [],
      MaritalStatus: [],
      PAN: [],
      JoiningDate: [],
      DepartmentID: [],
      DepartmentIDName: [],
      DesignationID: [],
      DesignationIDName: [],
      ReportingToID: [],
      ReportingToIDName: [],
      BranchCode: [],
      PaymentModeID: [],
      BankName: [],
      AccountNumber: [],
      IFSCCode: [],
      FatherName: [],
      Address1: [],
      Address2: [],
      City: [],
      StateID: [],
      StateIDName: [],
      PinCode: [],
      BloodGroup: [],
      WorkTimingFrom: [],
      WorkTimingTo: [],
      PhotoURL: [],
      PersonalPhone: [],
      PersonalEmail: [],
      Reference1: [],
      Reference2: [],
      Releieved: [],
      isActive: []
    });
  }

  ngOnInit(): void {
    this.EmployeeForm.get("DoB").setValue(this.today);
    this.EmployeeForm.get("Gender").setValue('m');
    this.EmployeeForm.get("MaritalStatus").setValue('S');
    this.FileList = [];
    this.getPaymentMode();
    this.getBranch();
    this.GridInit();
    this.route.queryParams.subscribe(params => {
      if (params.EmployeeID) {
        this.GetInvoiceData(params.EmployeeID);
      }
    });
  }

  GetInvoiceData(TransID) {

    this.GetInvoice(TransID).then((list: any) => {
      // this.EmployeeForm.disable();
      let headerDetails: any;
      let rateDetails: any;
      headerDetails = list.result.Table;
      rateDetails = list.result.Table1;

      this.EmployeeForm.get("EmployeeID").setValue(headerDetails[0].EmployeeID);
      this.EmployeeForm.get("EmpCode").setValue(headerDetails[0].EmpCode);
      this.EmployeeForm.get("FullName").setValue(headerDetails[0].FullName);
      this.EmployeeForm.get("Email").setValue(headerDetails[0].Email);
      this.EmployeeForm.get("Mobile").setValue(headerDetails[0].Mobile);
      this.EmployeeForm.get("Gender").setValue(headerDetails[0].Gender);
      this.EmployeeForm.get("AadhaarNo").setValue(headerDetails[0].AadhaarNo);
      this.EmployeeForm.get("DoB").setValue(headerDetails[0].DoB);
      this.EmployeeForm.get("MaritalStatus").setValue(headerDetails[0].MaritalStatus);
      this.EmployeeForm.get("PAN").setValue(headerDetails[0].PAN);
      this.EmployeeForm.get("JoiningDate").setValue(headerDetails[0].JoiningDate);
      this.EmployeeForm.get("DepartmentID").setValue(headerDetails[0].DepartmentID);
      this.EmployeeForm.get("DepartmentIDName").setValue(headerDetails[0].DepartmentIDName);
      this.EmployeeForm.get("DesignationID").setValue(headerDetails[0].DesignationID);
      this.EmployeeForm.get("DesignationIDName").setValue(headerDetails[0].DesignationIDName);
      this.EmployeeForm.get("ReportingToID").setValue(headerDetails[0].ReportingToID);
      this.EmployeeForm.get("ReportingToIDName").setValue(headerDetails[0].ReportingToIDName);
      this.EmployeeForm.get("BranchCode").setValue(headerDetails[0].BranchCode);
      this.EmployeeForm.get("PaymentModeID").setValue(headerDetails[0].PaymentModeID);
      this.EmployeeForm.get("BankName").setValue(headerDetails[0].BankName);
      this.EmployeeForm.get("AccountNumber").setValue(headerDetails[0].AccountNumber);
      this.EmployeeForm.get("IFSCCode").setValue(headerDetails[0].IFSCCode);
      this.EmployeeForm.get("FatherName").setValue(headerDetails[0].FatherName);
      this.EmployeeForm.get("Address1").setValue(headerDetails[0].Address1);
      this.EmployeeForm.get("Address2").setValue(headerDetails[0].Address2);
      this.EmployeeForm.get("City").setValue(headerDetails[0].City);
      this.EmployeeForm.get("StateID").setValue(headerDetails[0].StateID);
      this.EmployeeForm.get("StateIDName").setValue(headerDetails[0].StateIDName);
      this.EmployeeForm.get("PinCode").setValue(headerDetails[0].PinCode);
      this.EmployeeForm.get("BloodGroup").setValue(headerDetails[0].BloodGroup);
      this.EmployeeForm.get("WorkTimingFrom").setValue(headerDetails[0].WorkTimingFrom);
      this.EmployeeForm.get("WorkTimingTo").setValue(headerDetails[0].WorkTimingTo);
      this.EmployeeForm.get("PhotoURL").setValue(headerDetails[0].PhotoURL);
      this.EmployeeForm.get("PersonalPhone").setValue(headerDetails[0].PersonalPhone);
      this.EmployeeForm.get("PersonalEmail").setValue(headerDetails[0].PersonalEmail);
      this.EmployeeForm.get("Reference1").setValue(headerDetails[0].Reference1);
      this.EmployeeForm.get("Reference2").setValue(headerDetails[0].Reference2);
      this.EmployeeForm.get("Releieved").setValue(headerDetails[0].Releieved);
      this.EmployeeForm.get("isActive").setValue(headerDetails[0].isActive);
      let PhotoURL = this.property.WebAPIipAndPort + "/FileUploads/BSS/Employee/" + headerDetails[0].PhotoURL;
      // alert(PhotoURL);
      this.Gridsource.localdata = rateDetails;
      this.GridAdapter = new jqx.dataAdapter(this.Gridsource);
      $(".invoiceGrid").jqxGrid('updatebounddata');
      $(".invoiceGrid").jqxGrid({ disabled: false });

    });

  }

  GetInvoice(TransID) {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.WebAPImasteruri + "/HR/Get_EmployeeMaster?EmployeeID=" + TransID)
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  getDepartmentList() {
    return new Promise((resolve) => {
      this.http.get(this.WebAPImasteruri + '/item-activity/item-activity-auto', { params: { value: "HR DEPT", search: "" } }).subscribe((res: any) => {

        if (res != null) {
          resolve(res.body);
          this.DepartmentList = res.result.Table;
        }
        else {
          alert("No Records Found")
        }
      });
    });
  }

  DepartmentParams(value: any) {
    let scope = this;
    if (value.length > 0) {
      return new Promise((res) => {
        res({ search: value, value: "HR DEPT" });
      });
    } else {
      return new Promise((res) => {
        res({ search: 'z1z1z1z1z1z1z1z1z1z1z', value: "HR DEPT" });
      });
    }
  }

  DesignationParams(value: any) {
    let scope = this;
    if (value.length > 0) {
      return new Promise((res) => {
        res({ search: value, value: "HR DESG" });
      });
    } else {
      return new Promise((res) => {
        res({ search: 'z1z1z1z1z1z1z1z1z1z1z', value: "HR DESG" });
      });
    }
  }

  ReportingToParams(value: any) {
    let scope = this;
    if (value.length > 0) {
      return new Promise((res) => {
        res({ Type: "ALL", searchText: value });
      });
    } else {
      return new Promise((res) => {
        res({ searchText: 'z1z1z1z1z1z1z1z1z1z1z', Type: "ALL" });
      });
    }
  }

  BranchCodeParams(value: any) {
    let scope = this;
    if (value.length > 0) {
      return new Promise((res) => {
        res({});
      });
    } else {
      return new Promise((res) => {
        res({});
      });
    }
  }

  StateParams(value: any) {
    let scope = this;
    if (value.length > 0) {
      return new Promise((res) => {
        res({ searchText: value });
      });
    } else {
      return new Promise((res) => {
        res({ searchText: 'z1z1z1z1z1z1z1z1z1z1z' });
      });
    }
  }

  getPaymentMode() {
    return new Promise((resolve) => {
      this.http.get(this.WebAPImasteruri + '/item-activity/item-activity-auto', { params: { value: "RECEIPT MODE", search: "%" } }).subscribe((res: any) => {
        console.log('Response', res.body);
        if (res != null) {
          resolve(res.body);
          this.PaymentModeList = res.result.Table;

        }
        else {
          alert("No Records Found")
        }
      });
    });
  }

  onPaymentModeChange(event) {
    console.log(event);

  }

  getBranch() {
    return new Promise((resolve) => {
      this.http.get(this.WebAPImasteruri + '/branch/allbranchMasterList', { params: {} }).subscribe((res: any) => {
        console.log('Response', res.body);
        if (res != null) {
          resolve(res.body);
          this.BranchList = res.result.Table;

        }
        else {
          alert("No Records Found")
        }
      });
    });
  }

  GridInit() {
    var compScope = this;
    let chargeurl = this.WebAPImasteruri + '/item-activity/item-activity-auto?value=HR RELATION&search=%';
    let chargeLabelInput1: any;

    this.GridColumns =
      [
        {
          text: 'S.No', width: '3%', editable: false, sortable: false, menu: false, cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 5px;">' + (1 + row) + '</div>';
          }
        },
        { text: 'EmpDepID', datafield: 'EmpDepID', width: '10%', editable: true, hidden: true },
        { text: 'EmployeeID', datafield: 'EmployeeID', width: '10%', editable: true, hidden: true },
        { text: 'DependentName', datafield: 'DependentName', width: '15%', editable: true, hidden: false },
        {
          text: 'Relationship <span style="color:red">*</span>', width: '15%', datafield: 'RelationshipIDName', columntype: 'custom',
          createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
            chargeLabelInput1 = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, chargeurl, 'RelationshipIDName', undefined, function (obj) {
              // $(".invoiceGrid").jqxGrid('setcellvalue', row, 'RelationshipID', obj.Value);

            });
          },
          initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
            this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, chargeLabelInput1);
          },
          geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
            return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.invoiceGrid, 'RelationshipID', chargeLabelInput1);
          },
          // validation: function (_cell, valueMember, _row) {
          //   var AmountOnly = $(".invoiceGrid").jqxGrid('getcellvalue', _cell.row, 'AmountOnly');
          //   if(AmountOnly != 0){
          //     if (valueMember === "") {
          //       return { message: "TDS is Required" };
          //     } else{
          //       return true;
          //     }
          //   }else{
          //     return true;
          //   }

          // }

        },
        { text: 'RelationshipID', datafield: 'RelationshipID', width: '10%', editable: true, hidden: true },

        { text: 'Date of Birth', datafield: 'DepDoB', width: '12%', editable: true, hidden: false, cellsformat: 'dd/MM/yyyy', columntype: 'datetimeinput', class: "form-control" },

      ];

    this.Gridsource =
    {
      datatype: 'json',
      datafields: [
        { name: 'EmpDepID', type: 'int' },
        { name: 'EmployeeID', type: 'int' },
        { name: 'RelationshipID', type: 'int' },
        { name: 'DependentName', type: 'string' },
        { name: 'DepDoB', type: 'date' },
        { name: 'RelationshipIDName', type: 'string' },

      ],
      id: 'invid',
      localdata: [
        {
          "EmpDepID": 0,
          "EmployeeID": 0,
          "RelationshipID": 0
        }
      ]
    };
    this.GridAdapter = new $.jqx.dataAdapter(this.Gridsource);
    this.GridToolBar = (toolbar: any): void => {
      if (!this.commonService.isEmpty(toolbar)) {
        let buttonIdObj = {
          add: 'commodityAdd',
          delete: 'commodityDelete',
        }

        let tooBarObj = {
          currenComponentObj: this,
          gridObj: this.invoiceGrid,
          toolbarObj: toolbar,
          buttonObj: buttonIdObj,
          gridTitle: "",
          addRowMethodObj: this.addGridNewRow,
          deleteRowMethodObj: this.deleteRowCommodityGrid,
        }
        this.gridService.generateToolBar(tooBarObj);
      };
    }
  }

  addGridNewRow(obj) {
    let Amount = 0;
    var containerGridRows = $('.invoiceGrid').jqxGrid('getrows');
    let INC = 0;
    containerGridRows.forEach(element => {
      INC = INC + 1;
      Amount = element.Amount;
    });
    if (Amount == 0) {
      let invoiceGridMondatoryValidation = obj.gridService.checkGridMondatory(".invoiceGrid", ['DependentName']);
      if (invoiceGridMondatoryValidation) {
        let row = {};
        row['EmpDepID'] = 0
        row['EmployeeID'] = 0
        row['RelationshipID'] = 0
        return row;
      }
    } else {
      let invoiceGridMondatoryValidation = obj.gridService.checkGridMondatory(".invoiceGrid", ['DependentName']);
      if (invoiceGridMondatoryValidation) {
        let row = {};
        row['EmpDepID'] = 0
        row['EmployeeID'] = 0
        row['RelationshipID'] = 0
        return row;
      }
    }

  }
  deleteRowCommodityGrid(obj) {
    let selectedrowindex = obj.invoiceGrid.getselectedrowindex();
    let selectedrowindexes = obj.invoiceGrid.getselectedrowindexes();
    let rowscount = obj.invoiceGrid.getdatainformation().rowscount;
    if (selectedrowindexes.length > 0) {
      if (Number(rowscount) > 0) {
        let deleteRows: any = [];
        selectedrowindexes.forEach(index => {
          let id = obj.invoiceGrid.getcellvalue(selectedrowindex, 'EmpDepID')
          if (id) {
            var rowData = obj.invoiceGrid.getrowdata(index)
            rowData.isActive = 0;
            rowData.isReject = 0;
            rowData.isApproval = 0;
            obj.deletedGridRowList.push(rowData);
            let rowId = obj.invoiceGrid.getrowid(index);
            deleteRows.push(rowId);
          } else {
            let rowId = obj.invoiceGrid.getrowid(index);
            deleteRows.push(rowId);
          }
        });
        if (deleteRows.length > 0) {
          obj.invoiceGrid.deleterow(deleteRows);
          if (!$(".invoiceGrid").jqxGrid('getrows').length) {
            $(".invoiceGrid").jqxGrid("clear");
            $(".invoiceGrid").jqxGrid("addrow", 0, obj.addGridNewRow(obj));
          }
        }
      }
    } else {
      obj.alert.openSnackBar("No row selected", '');
    }
  }

  Save() {
    if (this.property.roleId == this.property.DefaultRoleId) {
      // let invoiceFinalGridRows: Array<any> = [];
      var frmObj = this.EmployeeForm.getRawValue();
      frmObj.OuCode = this.property.OuCode;
      frmObj.isActive = 1;
      frmObj.UpdatedBy = this.property.userId;
      if (!frmObj.EmployeeID) {
        delete frmObj.EmployeeID;
        frmObj.CreatedBy = this.property.userId;
      }
      if (!frmObj.EmpCode) {
        delete frmObj.EmpCode;
      }
      if (!frmObj.FullName) {
        delete frmObj.FullName;
      }
      if (!frmObj.Email) {
        delete frmObj.Email;
      }
      if (!frmObj.Mobile) {
        delete frmObj.Mobile;
      }
      if (!frmObj.Gender) {
        delete frmObj.Gender;
      }
      if (!frmObj.AadhaarNo) {
        delete frmObj.AadhaarNo;
      }
      if (!frmObj.DoB) {
        delete frmObj.DoB;
      } else {
        frmObj.DoB = this.datePipe.transform(frmObj.DoB, 'MM-dd-yyyy');
      }
      if (!frmObj.MaritalStatus) {
        delete frmObj.MaritalStatus;
      }
      if (!frmObj.PAN) {
        delete frmObj.PAN;
      }
      if (!frmObj.JoiningDate) {
        delete frmObj.JoiningDate;
      } else {
        frmObj.JoiningDate = this.datePipe.transform(frmObj.JoiningDate, 'MM-dd-yyyy');
      }
      if (!frmObj.DepartmentID) {
        delete frmObj.DepartmentID;
      }

      if (!frmObj.DepartmentIDName) {
        delete frmObj.DepartmentIDName;
      }
      if (!frmObj.DesignationID) {
        delete frmObj.DesignationID;
      }
      if (!frmObj.DesignationIDName) {
        delete frmObj.DesignationIDName;
      }
      if (!frmObj.ReportingToID) {
        delete frmObj.ReportingToID;
      }
      if (!frmObj.ReportingToIDName) {
        delete frmObj.ReportingToIDName;
      }
      if (!frmObj.BranchCode) {
        delete frmObj.BranchCode;
      }
      if (!frmObj.PaymentModeID) {
        delete frmObj.PaymentModeID;
      }
      if (!frmObj.BankName) {
        delete frmObj.BankName;
      }
      if (!frmObj.AccountNumber) {
        delete frmObj.AccountNumber;
      }
      if (!frmObj.IFSCCode) {
        delete frmObj.IFSCCode;
      }
      if (!frmObj.FatherName) {
        delete frmObj.FatherName;
      }
      if (!frmObj.Address1) {
        delete frmObj.Address1;
      }
      if (!frmObj.Address2) {
        delete frmObj.Address2;
      }
      if (!frmObj.City) {
        delete frmObj.City;
      }
      if (!frmObj.StateID) {
        delete frmObj.StateID;
      }
      if (!frmObj.StateIDName) {
        delete frmObj.StateIDName;
      }
      if (!frmObj.PinCode) {
        delete frmObj.PinCode;
      }
      if (!frmObj.BloodGroup) {
        delete frmObj.BloodGroup;
      }
      if (!frmObj.WorkTimingFrom) {
        delete frmObj.WorkTimingFrom;
      } else {
        frmObj.WorkTimingFrom = this.datePipe.transform(frmObj.WorkTimingFrom, 'MM-dd-yyyy');
      }
      if (!frmObj.WorkTimingTo) {
        delete frmObj.WorkTimingTo;
      } else {
        frmObj.WorkTimingTo = this.datePipe.transform(frmObj.WorkTimingTo, 'MM-dd-yyyy');
      }
      if (!frmObj.PhotoURL) {
        delete frmObj.PhotoURL;
      }
      if (!frmObj.PersonalPhone) {
        delete frmObj.PersonalPhone;
      }
      if (!frmObj.PersonalEmail) {
        delete frmObj.PersonalEmail;
      }
      if (!frmObj.Reference1) {
        delete frmObj.Reference1;
      }
      if (!frmObj.Reference2) {
        delete frmObj.Reference2;
      }

      if (!frmObj.Releieved) {
        delete frmObj.Releieved;
      } else {
        frmObj.Releieved = this.datePipe.transform(frmObj.Releieved, 'MM-dd-yyyy');
      }
      if (this.StoredFileName) {
        frmObj.PhotoURL = this.StoredFileName;
      }
      // var invoiceGridRows = $('.invoiceGrid').jqxGrid('getrows');
      // invoiceGridRows.forEach(element => {
      //   element.isActive = 1;
      //   element.EmployeeID = frmObj.EmployeeID;
      //   element.OuCode = this.property.OuCode;
      //   element.UpdatedBy = this.property.userId;
      //   if (!element.EmpDepID) {
      //     delete element.EmpDepID;
      //     element.CreatedBy = this.property.userId;
      //   }
      //   if (!element.DependentName) {
      //     delete element.DependentName;
      //   }
      //   if (!element.RelationshipID) {
      //     delete element.RelationshipID;
      //   }

      //   if (!element.DepDoB) {
      //     delete element.DepDoB;
      //   } else {
      //     element.DepDoB = this.datePipe.transform(element.DepDoB, 'MM-dd-yyyy');
      //   }

      //   invoiceFinalGridRows.push(element);
      // });
      // frmObj.Detail = invoiceFinalGridRows;
      this.httpRequestService.postBSS(this.WebAPImasteruri + "/HR/Update_EmployeeMaster", frmObj).then((response: any) => {

        if (response.status == 200) {
          if (response.result.Table[0].Number) {
            this.alert.openSnackBar(response.result.Table[0].Message + ' ' + response.result.Table[0].Number, '1');
          } else {
            this.alert.openSnackBar(response.result.Table[0].Message, '1');
          }
          this.Clear();
        } else if (response.status == 400) {
          this.alert.openSnackBar(response.result, '');
        }
      }, (error: any) => {
      });
    } else {
      this.alert.openSnackBar('Access Denied', '');
    }
  }

  Clear() {
    this.EmployeeForm.reset();
    this.EmployeeForm.enable();
    $(".invoiceGrid").jqxGrid('clear');
    this.EmployeeForm.get("DoB").setValue(this.today);
    this.EmployeeForm.get("Gender").setValue('m');
    this.EmployeeForm.get("MaritalStatus").setValue('S');
    this.GridInit();
    $(".invoiceGrid").jqxGrid({ disabled: false });
    this.FileList = [];
  }

  onHBLFileSelected(event) {
    let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    this.imageUpload(files);
  }
  imageUpload(file) {
    var formData = new FormData();
    for (let i = 0; i < file.length; i++) {
      var fileExtension = '.' + file[i].name.split('.').pop();
      const strbval = 'Emp_' + Math.random().toString(36).substring(7) + new Date().getTime() + fileExtension;
      Object.defineProperty(file[i], 'name', {
        writable: true,
        value: strbval
      });
      formData.append('fileUpload', file[i]);
    }

    this.FileList = [];

    // var frmObj = this.ImportSellRateForm.getRawValue();

    this.http.post(this.WebAPImasteruri + "/FileStorage/uploadFile?FolderName=" + 'Employee', formData).subscribe((response: any) => {
      if (response) {
        let StoredFileName = response.result.Table1[0].StoredFileName;
        let FileName = response.result.Table1[0].FileName;
        this.StoredFileName = StoredFileName;
        // alert(StoredFileName);
        // response.result.Table1.forEach(eleme => {

        //   eleme.isActive = 1;

        //   this.FileList.push(eleme);
        // });
      } else if (!response) {
        this.alert.openSnackBar('Error Occured While Document Upload', '');
      }
    }, (error: any) => {
      console.log('imageUpload save Error Occured', error);
    });
  }

}
